import {Race} from "@model";

export class StartRaces {
  races?: Race[];
  startOnlyCompetitorsPresentOnStart?: boolean;
  raceStartDateType?:RaceStartDateType
}

export enum RaceStartDateType {
  START, EDIT, STOP
}
